// =========================================================================
// HelpyDoc · Modal — Sheet deslizable desde abajo
// =========================================================================
import { ReactNode } from 'react';

interface ModalProps {
  visible: boolean;
  onClose: () => void;
  titulo?: string;
  children: ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ visible, onClose, titulo, children }) => {
  if (!visible) return null;
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
        zIndex: 9000, display: 'flex', alignItems: 'flex-end',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--paper)', borderRadius: '24px 24px 0 0',
          width: '100%', padding: '20px 20px 36px',
          maxHeight: '80vh', overflowY: 'auto',
          animation: 'slideUp .25s cubic-bezier(.34,1.2,.64,1) both',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ width: 36, height: 4, background: 'var(--ink-200)', borderRadius: 2, margin: '0 auto 16px' }} />
        {titulo && (
          <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--navy)', marginBottom: 16 }}>
            {titulo}
          </div>
        )}
        {children}
      </div>
      <style>{`@keyframes slideUp { from { transform: translateY(100%); } to { transform: none; } }`}</style>
    </div>
  );
};
